/**
 * Office-fallback: stuur een proactieve Kleda dag-notificatie voor één order
 * (de "Stuur ETA nu"-knop). Roept het Brein-klare `POST /api/notify/send` aan —
 * dezelfde kern als de dagelijkse cron, idempotent en gegate op
 * `Bevestigingen_sturen__c`. Spiegelt het patroon van sync-mollie.ts.
 */
import { supabase } from './supabase';

export type EtaKind = 'aflever_eta' | 'ophaal_eta' | 'klaar';

interface Outcome {
  channel: string;
  status: string;
}

export interface SendEtaResult {
  ok: boolean;
  reason?: string;
  error?: string;
  sent: number;
  suppressed: number;
  skipped: number;
  failed: number;
  /** Kanalen die daadwerkelijk verstuurd zijn (bv. ['email','sms']). */
  channels: string[];
}

async function authHeader(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function sendOrderEta(orderId: string, kind: EtaKind): Promise<SendEtaResult> {
  const headers = await authHeader();
  const res = await fetch('/api/notify/send', {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ woId: orderId, kind }),
  });

  let payload: { ok?: boolean; reason?: string; error?: string; outcomes?: Outcome[] } = {};
  try {
    payload = await res.json();
  } catch {
    /* lege/niet-JSON respons */
  }

  const outcomes = Array.isArray(payload.outcomes) ? payload.outcomes : [];
  const count = (s: string) => outcomes.filter((o) => o.status === s).length;

  return {
    ok: res.ok && payload.ok !== false,
    reason: payload.reason,
    error: payload.error,
    sent: count('sent'),
    suppressed: count('suppressed'),
    skipped: count('skipped'),
    failed: count('failed'),
    channels: outcomes.filter((o) => o.status === 'sent').map((o) => o.channel),
  };
}
